export default __webpack_public_path__ + "static/media/Pattern8.b2fcfd21.png";